import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, authHeaders } from './api';

export const useSAData = (endpoint, params) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    const id = setTimeout(() => {
      axios.get(`${API}${endpoint}`, { headers: authHeaders(), params, signal: ctrl.signal })
        .then((r) => { setData(r.data); setLoading(false); })
        .catch((e) => { if (e.name !== 'CanceledError') { setLoading(false); toast.error('Failed to load analytics'); } });
    }, 200);
    return () => { clearTimeout(id); ctrl.abort(); };
  }, [endpoint, params]);
  return { data, loading };
};
